import React, { useEffect, useRef, useState } from 'react'
import './ClientAddEditForm.css'
import { Box, Grid, Typography } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import MobileNumber from '../../../../../utilities/MobileNumber/MobileNumber';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getAllAuthUsersRequest } from '../../../../authentication/AuthenticationApiActions';
import { deleteMemberForShowingMessage, getAllClientsRequset, addClientRequest, editClientRequest, getSingleClientDetailsRequest } from '../../../ConfigurationApiActions'
import { connect } from 'react-redux';
import CustomTheme from '../../../../../utilities/theme/theme.json'
import MessageModal from '../../../../../utilities/MessageModal/MessageModal'
import LoaderForSaveAndEdit from '../../../../../utilities/AppLoader/LoaderForSaveAndEdit'
const ClientAddEditForm = ({
    setSelectedRow,
    setAddNewClient,
    addNewClient,
    getAllAuthUsers,
    deleteMember,
    allUsers,
    setRowIndex,
    getAllClients,
    addClient,
    editClient,
    getClientDetails,
    rowIndex
}) => {
    const modalRef = useRef();

    const [membersListNames, setMembersListNames] = useState([])
    const [memberName, setMemberName] = useState(null)
    const [member, setMember] = useState(null);
    const [value, setValue] = useState(null)

    // vendors
    const [showCompanyName, setShowCompnayName] = useState(false);
    const [showCompanyAddress, setShowCompanyAddress] = useState(false);
    const [showContactPerson, setShowContactPerson] = useState(null);
    const [showContactPhone, setShowContactPhone] = useState(false);
    const [showContactEmail, setShowContactEmail] = useState(false);

    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false)
    const [phoneValidationMessage, setPhoneValidationMessage] = useState(null)
    const [isClientOnUpdateForm, setIsClientOnUpdateForm] = useState(false)
    const [addEditBtnShow, setAddEditBtnShow] = useState(false)
    const [addEditRes, setAddEditRes] = useState(null)
    const [isShowLoader, setIsShowLoader] = useState(false);
   
    const [clientFormData, setClientFormData] = useState({
        name: null,
        address: null,
        contactPerson: null,
        phoneNumber: null,
        emailId: null,
        members: []
    })
    useEffect(() => {
        getAllAuthUsers(true)
    }, [])


    useEffect(() => {
        setValue(null)
    }, [clientFormData.members])

    useEffect(() => {
        if (addNewClient) {
            setClientFormData({
                name: null,
                address: null,
                contactPerson: null,
                phoneNumber: null,
                emailId: null,
                members: []
            })
            setMembersListNames([])
            setShowCompanyAddress(false)
            setShowContactPerson(false)
            setShowContactPhone(false)
            setShowContactEmail(false);
            setShowCompnayName(false)
            setAddEditBtnShow(false)
            setAddEditRes('')
        }
    }, [addNewClient])


    useEffect(() => {
        if (rowIndex) {
            setIsShowLoader(true)
            getClientDetails(rowIndex).then((res) => {
                let clientData = Object.assign([], clientFormData);
                let arr = [];
                res.members && Object.keys(res.members).map((name, nameIndex) => {
                    arr.push(`${res.members[name].firstName} ${res.members[name].lastName}`)
                    return name
                })

                let arrForIds = [];
                res.members && Object.keys(res.members).map((name, nameIndex) => {
                    arrForIds.push(res.members[name].id)
                    return name
                })

                clientData.name = res.name
                clientData.address = res.address
                clientData.contactPerson = res.contactPerson
                clientData.phoneNumber = res.phoneNumber
                clientData.emailId = res.emailId
                clientData.members = arrForIds
                setClientFormData(clientData)
                setMembersListNames(arr)
                setShowCompanyAddress(false)
                setShowContactPerson(false)
                setShowContactPhone(false)
                setShowContactEmail(false);
                setShowCompnayName(false)
                setAddEditBtnShow(true)
                setIsShowLoader(false)
                setAddNewClient(false)
            })
        } else { }
    }, [rowIndex, addEditRes])

    const clickHandler = () => {
        let data = {
            name: clientFormData.name,
        }
        if (clientFormData.address) {
            data.address = clientFormData.address
        } else {
        }
        if (clientFormData.contactPerson) {
            data.contactPerson = clientFormData.contactPerson
        } else {
            // data.contactPerson = ""
        }
        if (clientFormData.phoneNumber) {
            data.phoneNumber = clientFormData.phoneNumber
        } else {
        }
        if (clientFormData.emailId) {
            data.emailId = clientFormData.emailId
        } else {
        }
        if (clientFormData.members) {
            data.members = clientFormData.members
        } else {
        }
        if (rowIndex != null) {
            // edit vendor
            editClient(data, rowIndex).then((res) => {

                getAllClients()

                setRowIndex(res.id)
                setSelectedRow(res.id)
                setAddEditBtnShow(true)
                setAddEditRes(res)
            })
        } else {
            //Add Vendor
            addClient(data).then((res) => {

                getAllClients()

                setRowIndex(res.id)
                setSelectedRow(res.id)
                setAddEditBtnShow(true)
                setAddEditRes(res)

            })
        }
    }

    const updateMobileNumber = (phone, validPhoneNumber) => {
        handleChangeAutocomplete("phoneNumber", phone)
        setIsPhoneNumberValid(validPhoneNumber)
        if (validPhoneNumber || phone.length === 3) {
            setIsPhoneNumberValid(false)
            setPhoneValidationMessage('')
        } else {
            setIsPhoneNumberValid(true)
            setPhoneValidationMessage('Contact phone should 10 digit')
        }
    }


    const defaultProps = {
        options: allUsers || [],
        getOptionLabel: (option) => `${option.firstName} ${option.lastName}`,
    };


    const addMemeberHandler = () => {
        const data = Object.assign([], clientFormData.members);
        const newMemberObj = member;
        data.push(newMemberObj)
        setClientFormData({
            ...clientFormData,
            members: data
        })
        setMember('');

        const dataMemberName = Object.assign([], membersListNames);
        const newMemberNamesObj = memberName;
        dataMemberName.push(newMemberNamesObj)
        setMembersListNames(dataMemberName)

    }

    const deleteMemberHandler = (nameIndex) => {
        const data = Object.assign([], clientFormData.members);
        data.splice(nameIndex, 1);
        setClientFormData({
            ...clientFormData,
            members: data
        })

        const memberListNameData = Object.assign([], membersListNames);
        memberListNameData.splice(nameIndex, 1);
        setMembersListNames(memberListNameData);

        deleteMember();
    }

    const showAllValuesInFormHandler = () => {
        setAddEditBtnShow(false);
        setShowCompnayName(true)
        setShowCompanyAddress(true)
        setShowContactPerson(true)
        setShowContactPhone(true)
        setShowContactEmail(true);
        setAddNewClient(false)
    }

    const handleEsc = (e) => {
        if (e.keyCode === 27) {
            if (rowIndex) {
                if (!isClientOnUpdateForm) {
                    setAddNewClient(false)
                    setSelectedRow(null)
                } else {

                    const title = `Client`
                    const message = `Changes that you made in edit client may not be saved.`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setAddNewClient(false)
                            setSelectedRow(null)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });
                }
            } else {
                if (isClientOnUpdateForm) {
                    const title = `Client`
                    const message = `Changes that you made in Client may not be saved.`
                    modalRef.current.setState({
                        showModal: true,
                        message: message,
                        title: title,
                        showOkButton: true,
                        showCancelButton: true,
                        showNote: false,
                        note: '',
                        handleOk: (note) => {
                            setAddNewClient(false)
                            setSelectedRow(null)
                        },
                        okText: "Yes",
                        cancelText: 'No'
                    });
                } else {
                    setAddNewClient(false)
                }
            }
        }
    }

    const handleChangeInput = (event, value) => {
        const data = Object.assign({}, clientFormData);
        data[event.target.name] = event.target.value;
        if (!isClientOnUpdateForm) {
            setIsClientOnUpdateForm(true)
        } else {
        }
        setClientFormData(data)
    }
    /**
 * Method executes on onChange action of autocomplete form element
 */
    const handleChangeAutocomplete = (elementName, selectedvalue) => {
        let data = Object.assign({}, clientFormData);
        if (elementName === "phoneNumber") {
            data.phoneNumber = selectedvalue
            if (!isClientOnUpdateForm) {
                setIsClientOnUpdateForm(true)
            } else {
            }
        }
        else { }
        setClientFormData(data)
    }
    return (
        <>
            {
                isShowLoader
                    ?
                    <span className="loader-for-save-and-edit"><LoaderForSaveAndEdit /></span>
                    :
                    <>
                        <ValidatorForm
                            onSubmit={() => clickHandler()}
                            onKeyDown={(e) => handleEsc(e)}
                        >
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}
                                style={{ borderBottom: `1px dashed ${CustomTheme.primaryColor}` }}
                                className={"team-detail-panel-padding"}>
                                <Grid container justify="space-between">
                                    <Grid>
                                    </Grid>
                                    {
                                        addEditBtnShow
                                            ?
                                            <Grid onClick={() => {
                                                showAllValuesInFormHandler();
                                            }} className="team-detail-panel-save-btn"
                                                style={{ color: CustomTheme.primaryColor }}
                                            >
                                                <i className="far fa-edit"></i>
                                            </Grid>
                                            :
                                            <Grid className="save-btn-position-style">
                                                <Button size="small"
                                                    type="submit"
                                                    className="form-panel-save-btn submit-btn"
                                                    style={{ color: CustomTheme.primaryColor }}
                                                >
                                                    <i className="far fa-save"></i>
                                                </Button>
                                            </Grid>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}
                                className="padding-to-grid client-vendor-background-color">
                                <Grid container>
                                    <Grid xl={2} lg={2} md={2} sm={2} xs={2}>
                                        <Grid style={{ color: CustomTheme.primaryColor }}>
                                            <span className="edit-icon-small">
                                                {/* <i className="far fa-edit"></i> */}
                                            </span>
                                        </Grid>
                                        <Grid>
                                            {/* <img className="image-icon-grid" src={SampleImage} /> */}
                                            {
                                                clientFormData.contactPerson && clientFormData.contactPerson !== ""
                                                    ?
                                                    <Avatar
                                                        className="image-icon-grid-by-default">{clientFormData.contactPerson.charAt(0).toUpperCase()}</Avatar>
                                                    :
                                                    <Avatar className="image-icon-grid-by-default"></Avatar>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid xl={10} lg={10} md={10} sm={10} xs={10}>
                                        {
                                            showCompanyName
                                                ?
                                                <Grid>
                                                    <TextValidator
                                                        fullWidth
                                                        autoFocus
                                                        // required
                                                        // variant="outlined"
                                                        size="small"
                                                        label="Company Name"
                                                        onChange={handleChangeInput}
                                                        name="name"
                                                        value={clientFormData.name || ''}
                                                        validators={['required', 'trim', 'maxStringLength:50']}
                                                        errorMessages={['This field is required', 'At least one alphanumeric characters', 'The max length of 50 charachers reached']}
                                                    />
                                                </Grid>
                                                :
                                                <>
                                                    {
                                                        rowIndex
                                                            ?
                                                            <Grid>
                                                                <Typography variant="h1"
                                                                    style={{ color: CustomTheme.primaryColor }}
                                                                    className="add-title-text">
                                                                    <span>
                                                                        {clientFormData.name}
                                                                    </span>
                                                                </Typography>
                                                            </Grid>
                                                            :
                                                            <Grid onClick={() => setShowCompnayName(true)}>
                                                                <Typography variant="h2"
                                                                    style={{ color: CustomTheme.primaryColor }}
                                                                    className="add-title-text">
                                                                    <i className="far fa-edit"></i> <span>Click to add company name</span>
                                                                </Typography>
                                                            </Grid>
                                                    }
                                                </>
                                        }
                                        {
                                            showCompanyAddress
                                                ?
                                                <Grid className="description-input-container">
                                                    <TextValidator
                                                        fullWidth
                                                        autoFocus
                                                        // required
                                                        // variant="outlined"
                                                        size="small"
                                                        multiLine={true}
                                                        label="Company Address"
                                                        onChange={handleChangeInput}
                                                        name="address" value={clientFormData.address || ''}
                                                        validators={['required', 'trim', 'maxStringLength:250']}
                                                        errorMessages={['This field is required', 'At least one alphanumeric characters', 'The max length of 250 charachers reached']}
                                                    />
                                                </Grid>
                                                :
                                                <>
                                                    {
                                                        rowIndex
                                                            ?
                                                            <Grid>
                                                                <Typography variant="h3"
                                                                    style={{ color: CustomTheme.primaryColor }}
                                                                    className="add-description-text">
                                                                    <span>
                                                                        {clientFormData.address}
                                                                    </span>
                                                                </Typography>
                                                            </Grid>
                                                            :
                                                            <Grid onClick={() => setShowCompanyAddress(true)}>
                                                                <Typography variant="h3"
                                                                    style={{ color: CustomTheme.primaryColor }}
                                                                    className="add-description-text">
                                                                    <i className="far fa-edit"></i> <span>
                                                                        Click to add a company address for this client
                                                                    </span>
                                                                </Typography>
                                                            </Grid>
                                                    }
                                                </>

                                        }
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}
                                className="padding-to-grid margin-top-team-btn">
                                <Grid container>
                                    <Grid style={{ color: CustomTheme.fontColor, paddingTop: '6px' }} item xl={1} lg={1} md={1} sm={12}
                                        xs={12}>
                                        <span className="client-vendor-contact-icons"><i
                                            className="far fa-user"></i></span>
                                    </Grid>
                                    {
                                        showContactPerson
                                            ?
                                            <Grid className="client-vendor-input-grid" item xl={10} lg={10} md={10}
                                                sm={12} xs={12}>
                                                <TextValidator
                                                    fullWidth
                                                    // required
                                                    autoFocus
                                                    // variant="outlined"
                                                    size="small"
                                                    label="Contact Person"
                                                    onChange={handleChangeInput}
                                                    name="contactPerson" value={clientFormData.contactPerson || ''}
                                                    validators={['required', 'trim', 'maxStringLength:50']}
                                                    errorMessages={['This field is required', 'At least one alphanumeric characters', 'The max length of 50 charachers reached']}
                                                />
                                            </Grid>
                                            :
                                            <>
                                                {
                                                    rowIndex
                                                        ?
                                                        <Grid className="client-vendor-contact-text-grid">
                                                            <Grid>
                                                                <Typography variant="body2" style={{
                                                                    color: CustomTheme.fontColor,
                                                                    paddingBottom: '3px'
                                                                }} className="client-vendor-contact-person">Contact
                                                                    Person</Typography>
                                                            </Grid>
                                                            <Grid style={{ color: CustomTheme.fontColor }}
                                                                className="client-vendor-contact-person-name">
                                                                <Typography variant="body1"
                                                                    style={{ color: CustomTheme.primaryColor }}><span
                                                                        className="edit-icon-small"></span>{clientFormData.contactPerson}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        <Grid className="client-vendor-click-to-add-text">
                                                            <Typography variant="h3"
                                                                onClick={() => setShowContactPerson(true)}
                                                                style={{ color: CustomTheme.primaryColor }}
                                                                className="add-description-text">
                                                                <i className="far fa-edit"></i> <span style={{ color: CustomTheme.primaryColor }}
                                                                    className="edit-icon-small">
                                                                    Click to add a contact person for client
                                                                </span>
                                                            </Typography>
                                                        </Grid>
                                                }
                                            </>

                                    }

                                </Grid>
                            </Grid>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="padding-to-grid">
                                <Grid container>
                                    <Grid style={{ color: CustomTheme.fontColor, paddingTop: '5px' }} item xl={1} lg={1} md={1} sm={12}
                                        xs={12}>
                                        <span className="client-vendor-contact-icons"><i
                                            className="fas fa-phone-alt"></i></span>
                                    </Grid>
                                    {
                                        showContactPhone
                                            ?
                                            <Grid className="client-vendor-input-grid-for-contact-phone" item xl={10}
                                                lg={10} md={10} sm={12} xs={12}>
                                                <MobileNumber updateMobileNumber={updateMobileNumber}
                                                    specialLabel="Contact Phone" phone={clientFormData.phoneNumber} />
                                                {
                                                    isPhoneNumberValid
                                                        ?
                                                        <Typography
                                                            className="error-message-phone">{phoneValidationMessage}</Typography>
                                                        :
                                                        <></>
                                                }
                                            </Grid>
                                            :
                                            <>
                                                {
                                                    rowIndex
                                                        ?
                                                        <Grid className="client-vendor-contact-text-grid">
                                                            <Grid>
                                                                <Typography variant="body2" style={{
                                                                    color: CustomTheme.fontColor,
                                                                    paddingBottom: '4px'
                                                                }} className="client-vendor-contact-person">Contact
                                                                    Phone</Typography>
                                                            </Grid>
                                                            <Grid style={{ color: CustomTheme.primaryColor }}
                                                                className="client-vendor-contact-person-phone-email">
                                                                <Typography variant="body1"
                                                                    style={{ color: CustomTheme.primaryColor }}><span
                                                                        className="edit-icon-small"></span>{clientFormData.phoneNumber}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        <Grid className="client-vendor-click-to-add-text">
                                                            <Typography variant="h3"
                                                                onClick={() => setShowContactPhone(true)}
                                                                style={{ color: CustomTheme.primaryColor }}
                                                                className="add-description-text">
                                                                <i className="far fa-edit"></i><span style={{ color: CustomTheme.primaryColor }}
                                                                    className="edit-icon-small">
                                                                    Click to add a contact phone for client
                                                                </span>
                                                            </Typography>
                                                        </Grid>
                                                }
                                            </>

                                    }


                                </Grid>
                            </Grid>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="padding-to-grid">
                                <Grid container>
                                    <Grid style={{ color: CustomTheme.fontColor, paddingTop: '5px' }} item xl={1} lg={1} md={1} sm={12}
                                        xs={12}>
                                        <span className="client-vendor-contact-icons"><i
                                            className="far fa-envelope"></i></span>
                                    </Grid>
                                    {
                                        showContactEmail
                                            ?
                                            <Grid className="client-vendor-input-grid" item xl={10} lg={10} md={10}
                                                sm={12} xs={12}>
                                                <TextValidator
                                                    fullWidth
                                                    autoFocus
                                                    // required
                                                    // variant="outlined"
                                                    size="small"
                                                    label="Contact Email"
                                                    onChange={handleChangeInput}
                                                    name="emailId" value={clientFormData.emailId || ''}
                                                    validators={['required', 'isEmail']}
                                                    errorMessages={['This field is required', 'Email is not valid']}
                                                />
                                            </Grid>
                                            :
                                            <>
                                                {
                                                    rowIndex
                                                        ?
                                                        <Grid className="client-vendor-contact-text-grid">
                                                            <Grid>
                                                                <Typography variant="body2" style={{
                                                                    color: CustomTheme.fontColor,
                                                                    paddingBottom: '3px'
                                                                }} className="client-vendor-contact-person">Contact
                                                                    Email</Typography>
                                                            </Grid>
                                                            <Grid style={{ color: CustomTheme.primaryColor }}
                                                                className="client-vendor-contact-person-phone-email">
                                                                <Typography variant="body1"
                                                                    style={{ color: CustomTheme.primaryColor }}><span
                                                                        className="edit-icon-small"></span>{clientFormData.emailId}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        :
                                                        <Grid className="client-vendor-click-to-add-text">
                                                            <Typography variant="h3"
                                                                onClick={() => setShowContactEmail(true)}
                                                                style={{ color: CustomTheme.primaryColor }}
                                                                className="add-description-text">
                                                                <i className="far fa-edit"></i> < span style={{ color: CustomTheme.primaryColor }}
                                                                    className="edit-icon-small">
                                                                    Click to add a contact email for client
                                                                </span>
                                                            </Typography>
                                                        </Grid>
                                                }
                                            </>

                                    }
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                        {
                            addEditBtnShow
                                ?
                                <></>
                                :
                                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}
                                    className="form-panel-assign-name-container team-detail-panel-memeber-container">
                                    <ValidatorForm
                                        onSubmit={() => value ? addMemeberHandler() : ''}
                                    >
                                        <Grid container>
                                            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                                                <Box className="team-detail-panel-add-member-box">
                                                    <Typography style={{ color: CustomTheme.fontColor }}><i
                                                        className="fas fa-user-plus"></i></Typography>
                                                    <Typography style={{ color: CustomTheme.fontColor }}
                                                        className="team-detail-panel-new-member-text">New
                                                        Member</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
                                                <Autocomplete
                                                    {...defaultProps}
                                                    className="team-detail-panel-inputbase"
                                                    value={value}
                                                    onChange={(event, newValue) => {
                                                        setValue(newValue);
                                                        setMember(newValue.id)
                                                        setMemberName(`${newValue.firstName} ${newValue.lastName}`)
                                                    }}
                                                    renderInput={(params) => <TextValidator   {...params} placeholder="New Member" />}
                                                />
                                            </Grid>
                                            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}
                                                className="team-detail-panel-add-member-btn">
                                                <Button size="small"
                                                    // disabled={value? false:true}
                                                    type="submit"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={value != null ? "blank-page-button-tasklist btn-margin-left" : "disable-add-btn blank-page-button-tasklist btn-margin-left"}><span
                                                        className="btn-margin-left">ADD</span>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </ValidatorForm>
                                </Grid>
                        }
                        {
                            rowIndex && membersListNames && membersListNames.length > 0
                                ?
                                <Grid className="memebers-title-on-read-only" item xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Grid>
                                        <Typography variant="body1" style={{ color: CustomTheme.fontColor }}
                                            className="form-panel-dependent-task-text">
                                            Members:
                                        </Typography>
                                    </Grid>
                                </Grid>
                                :
                                <></>
                        }
                        {
                            membersListNames && membersListNames.map((name, nameIndex) => {
                                return (
                                    <Grid key={nameIndex} item xl={12} lg={12} md={12} sm={12} xs={12}
                                        className="form-panel-assign-name-container ">
                                        <Grid container>
                                            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                                                <Typography
                                                    style={{ paddingLeft: rowIndex ? '15px' : '', color: CustomTheme.fontColor }}
                                                    className="team-detail-panel-memeber-name-text">{name}</Typography>
                                            </Grid>
                                            {
                                                addEditBtnShow
                                                    ?
                                                    <></>
                                                    :
                                                    <Grid onClick={() => deleteMemberHandler(nameIndex)} item xl={4} lg={4} md={4}
                                                        sm={12} xs={12}>
                                                        <Typography className="team-detail-panel-delete-memeber-icon"><i
                                                            className="far fa-times-circle"></i></Typography>
                                                    </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                        <MessageModal
                            ref={modalRef}
                        />
                    </>
            }
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        allUsers: state.auth.users,
        singleVendorDetail: state.configuration.singleVendorDetails,
        allVendors: state.configuration.vendors
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllClients: () => {
            return dispatch(getAllClientsRequset()).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        addClient: (data) => {
            return dispatch(addClientRequest(data)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        editClient: (data, clientId) => {
            return dispatch(editClientRequest(data, clientId)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getAllAuthUsers: (isLoaderShowing) => {
            return dispatch(getAllAuthUsersRequest(isLoaderShowing)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        getClientDetails: (id) => {
            return dispatch(getSingleClientDetailsRequest(id)).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
        deleteMember: () => {
            return dispatch(deleteMemberForShowingMessage())
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientAddEditForm);
